import { HTTP_METHOD } from '@tellus/http'

/**
 * system api
 */
export const httpApi = {
  Logout: {
    url: '/Permission/Logout',
    method: HTTP_METHOD.POST
  },
  Login: {
    url: '/Permissions/Login'
  },
  ChangePwd: {
    url: '/Permissions/ChangePwd',
    method: HTTP_METHOD.POST
  },
  UserInfo: {
    url: '/Permission/GetLoginUserInfo',
    method: HTTP_METHOD.GET
  },
  RouterNav: {
    url: '/Permission/GetUserMenu',
    method: HTTP_METHOD.POST
  },
  GetToken: {
    url: '/Permission/RefreshToken',
    method: HTTP_METHOD.POST
  },

  /*************注文用*************/

  //注文一覧：注文基本情報の検索
  SearchOrderBasic: {
    url: '/OrderBasic/SearchOrderBasic',
    method: HTTP_METHOD.POST
  },

  //注文一覧：検索条件リストの初期化(状態、支払状態)
  InitOrderSearchList: {
    url: '/OrderBasic/InitOrderSearchList',
    method: HTTP_METHOD.POST
  },

  //注文一覧：注文No.によると、注文基本情報と明細情報の削除
  DeleteOrderBasicByOrderNo: {
    url: '/OrderBasic/DeleteOrderBasicByOrderNo',
    method: HTTP_METHOD.POST
  },

  //注文明細：注文No.によると、注文基本情報と明細情報の検索
  SearchOrderDetailByOrderNo: {
    url: '/OrderDetail/SearchOrderDetailByOrderNo',
    method: HTTP_METHOD.POST
  },

  //注文明細：社内加工原価の取得
  SearchProcessCostByOrderNo: {
    url: '/OrderDetail/SearchProcessCostByOrderNo',
    method: HTTP_METHOD.POST
  },

  //注文明細：社内加工原価の更新
  UpdateProcessCostByOrderNo: {
    url: '/OrderDetail/UpdateProcessCostByOrderNo',
    method: HTTP_METHOD.POST
  },

  //注文明細：基本情報のリスト取得（仕入先、担当者）
  GetInitInfoList: {
    url: '/OrderDetail/GetInitInfoList',
    method: HTTP_METHOD.POST
  },

  //注文明細：仕入先コードによる製品情報の取得
  SearchOrderProcSupCode: {
    url: '/OrderDetail/SearchOrderProcSupCode',
    method: HTTP_METHOD.POST
  },

  //注文明細：注文基本情報と明細情報の新規追加
  AddOrderDetail: {
    url: '/OrderDetail/AddOrderDetail',
    method: HTTP_METHOD.POST
  },

  //注文明細：注文No.によると、注文基本情報と明細情報の更新
  UpdateOrderDetail: {
    url: '/OrderDetail/UpdateOrderDetail',
    method: HTTP_METHOD.POST
  },

  //受注製品選択：注文可能な受注情報の取得
  GetOrderableOrder: {
    url: '/OrderDetail/GetOrderableOrder',
    method: HTTP_METHOD.POST
  },

  // 注文書出力詳細：注文書出力情報の取得
  GetOrderOutPutInfo: {
    url: '/OrderBasic/GetOrderOutPutInfo',
    method: HTTP_METHOD.POST
  },

  // 注文書出力詳細：注文書出力
  OutPutOrderInfo: {
    url: '/OrderBasic/OutPutOrderInfo',
    method: HTTP_METHOD.POST,
  },

  // 注文出力詳細：注文出力
  OutPutOrderLedgerInfo: {
    url: '/OrderBasic/OutPutOrderLedgerInfo',
    method: HTTP_METHOD.POST,
  },

  // 注文出力詳細：配送単出力
  OutPutDeliveryOrder: {
    url: '/OrderBasic/OutPutDeliveryOrder',
    method: HTTP_METHOD.POST,
  },

  //注文明細：基本情報のリスト取得（異常区分、受注クローズ、支払区分）
  GetInitInfoListForRestock: {
    url: '/OrderDetail/GetInitInfoListForRestock',
    method: HTTP_METHOD.POST,
  },

  //注文明細：再入荷情報の検索
  SearchRestockInfoByObOrderNo: {
    url: '/OrderDetail/SearchRestockInfoByObOrderNo',
    method: HTTP_METHOD.POST,
  },

  //注文明細：再入荷情報の更新
  UpdateRestockInfoByObOrderNo: {
    url: '/OrderDetail/UpdateRestockInfoByObOrderNo',
    method: HTTP_METHOD.POST,
  },

  //注文明細：製品クローズ情報の検索
  SearchProductNormalInfoByObQuoteNoInOrder: {
    url: '/OrderDetail/SearchProductNormalInfoByObQuoteNoInOrder',
    method: HTTP_METHOD.POST,
  },

  //注文明細：製品クローズ情報の更新
  UpdateProductCloseSelectDataInOrder: {
    url: '/OrderDetail/UpdateProductCloseSelectDataInOrder',
    method: HTTP_METHOD.POST,
  },

  // 注文明細:製品クローズ選択の出力
  OutPutProductCloseSelectDataInOrderExcel: {
    url: '/OrderDetail/OutPutProductCloseSelectDataInOrderExcel',
    method: HTTP_METHOD.POST,
  },

  // 注文一覧：一括手配
  GetAddAllOrderInfo: {
    url: '/OrderBasic/GetAddAllOrderInfo',
    method: HTTP_METHOD.POST
  },

  // ADD 2025/03/19 ZLL 課題_出力後、状態の自動変更の追加 start↓
  // 出力後、状態の更新（手配：新規⇒手配済み、納品：新規⇒納品済み、請求：新規⇒請求済み）
  UpdateStatusAfterOutput: {
    url: '/OrderDetail/UpdateStatusAfterOutput',
    method: HTTP_METHOD.POST
  },
  // ADD 2025/03/19 ZLL 課題_出力後、状態の自動変更の追加 end↑

  CreatAddAllOrderInfo: {
    url: '/OrderBasic/CreatAddAllOrderInfo',
    method: HTTP_METHOD.POST
  },

  /*************注文用*************/

  // 角色检索初期化
  RoleSearch: {
    url: '/RoleMst/InitForSearch',
    method: HTTP_METHOD.POST
  },
  // 角色登录初期化
  RoleInitEntry: {
    url: '/RoleMst/InitForEntry',
    method: HTTP_METHOD.POST
  },
  // 角色变更初期化
  RoleInitChange: {
    url: '/RoleMst/InitForChange',
    method: HTTP_METHOD.POST
  },
  // 角色登录
  RoleEntry: {
    url: '/RoleMst/Entry',
    method: HTTP_METHOD.POST
  },
  // 角色存储重建
  RoleStoreBuild: {
    url: '/RoleStore/RefreshStore',
    method: HTTP_METHOD.GET
  },
  // 角色变更
  RoleChange: {
    url: '/RoleMst/Change',
    method: HTTP_METHOD.POST
  },
  // 用户检索初期化
  UserSearch: {
    url: '/UserMst/InitForSearch',
    method: HTTP_METHOD.POST
  },
  // 用户登录初期化
  UserInitEntry: {
    url: '/UserMst/InitForEntry',
    method: HTTP_METHOD.POST
  },
  // 用户变更初期化
  UserInitChange: {
    url: '/UserMst/InitForChange',
    method: HTTP_METHOD.POST
  },
  // 用户登录
  UserEntry: {
    url: '/UserMst/Entry',
    method: HTTP_METHOD.POST
  },
  // 用户变更
  UserChange: {
    url: '/UserMst/Change',
    method: HTTP_METHOD.POST
  },
  // 用户密码重置
  UserResetPassword: {
    url: '/UserMst/ResetPassword',
    method: HTTP_METHOD.POST
  },

  //部門のリスト取得
  InitUserDepartmentList: {
    url: '/UserMst/InitUserDepartmentList',
    method: HTTP_METHOD.POST
  },

  // domain 检索
  DomainSearch: {
    url: '/DomainMst/Search',
    method: HTTP_METHOD.POST
  },
  // domain 检索
  GetDomainDtoByDomainCode: {
    url: '/DomainMst/GetDomainDtoByDomainCode',
    method: HTTP_METHOD.POST
  },

  // domain 登录初期化
  DomainInitForEntry: {
    url: '/DomainMst/InitForEntry',
    method: HTTP_METHOD.POST
  },
  // domain 变更初期化
  DomainInitForChange: {
    url: '/DomainMst/InitForChange',
    method: HTTP_METHOD.POST
  },
  // domain 登录
  DomainEntry: {
    url: '/DomainMst/Entry',
    method: HTTP_METHOD.POST
  },
  // domain 变更
  DomainChange: {
    url: '/DomainMst/Change',
    method: HTTP_METHOD.POST
  },
  // 首页初期化
  HomeInit: {
    url: '/Home/Init',
    method: HTTP_METHOD.POST
  },

  ImportExcel: {
    url: '/api/ProcessFile/UploadExcel',
    method: HTTP_METHOD.POST,
  },

  // 取得仕入先マスタ情報
  GetSupInfo: {
    url: '/SupplierInfoMst/GetSupMstInfo',
    method: HTTP_METHOD.POST
  },

  // 見積依頼書出力
  OutPutEstimateDependencyExcel: {
    url: '/NumberDetail/OutPutEstimateDependencyExcel',
    method: HTTP_METHOD.POST
  },

  // 見積書出力
  OutPutQuotationExcel: {
    url: '/NumberDetail/OutPutQuotationExcel',
    method: HTTP_METHOD.POST
  },

    // 見積書出力
  OutPutQuotationPdf: {
    url: '/NumberDetail/OutPutQuotationPdf',
    method: HTTP_METHOD.POST
  },

  // 見積書情報の取得
  GetEstimateInfo: {
    url: '/NumberDetail/GetEstimateInfo',
    method: HTTP_METHOD.POST
  },

  //見積状態の自動変更
  EditQuoteStateByQuoteNo: {
    url: '/NumberDetail/EditQuoteStateByQuoteNo',
    method: HTTP_METHOD.POST
  },

  // 变更仕入先マスタ情報
  ChangeSupMstInfo: {
    url: '/SupplierInfoMst/ChangeSupMstInfo',
    method: HTTP_METHOD.POST
  },

  // 新規仕入先マスタ情報
  AddSupMstInfo: {
    url: '/SupplierInfoMst/AddSupMstInfo',
    method: HTTP_METHOD.POST
  },

  GetSupMstInfoByCode: {
    url: '/SupplierInfoMst/GetSupMstInfoByCode',
    method: HTTP_METHOD.POST
  },

  GetSelectList: {
    url: '/SupplierInfoMst/GetSelectList',
    method: HTTP_METHOD.POST
  },


  // 削除仕入先マスタ情報
  DeleteSupMstInfo: {
    url: '/SupplierInfoMst/DeleteSupMstInfo',
    method: HTTP_METHOD.POST
  },

  // 取得得意先マスタ情報
  GetCusMstInfo: {
    url: '/CustomersMst/GetCusMstInfo',
    method: HTTP_METHOD.POST
  },

  // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
  // 得意先マスタ情報の取得(納品詳細用の検索条件)
  GetCusMstInfoSend: {
    url: '/CustomersMst/GetCusMstInfoSend',
    method: HTTP_METHOD.POST
  },
  // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

  // 变更得意先マスタ情報
  ChangeCusMstInfo: {
    url: '/CustomersMst/ChangeCusMstInfo',
    method: HTTP_METHOD.POST
  },

  // 新規得意先マスタ情報
  AddCusMstInfo: {
    url: '/CustomersMst/AddCusMstInfo',
    method: HTTP_METHOD.POST
  },

  // 削除得意先マスタ情報
  DeleteCusMstInfo: {
    url: '/CustomersMst/DeleteCusMstInfo',
    method: HTTP_METHOD.POST
  },

  // 得意先マスタ情報の取得
  GetCusMstInfoByCode: {
    url: '/CustomersMst/GetCusMstInfoByCode',
    method: HTTP_METHOD.POST

  },

  // 担当得意先情報の検索
  SearchUserCustomer: {
    url: '/UserCustomersMst/SearchUserCustomerData',
    method: HTTP_METHOD.POST
  },

  // 担当得意先情報の変更
  UpdateUserCustomer: {
    url: '/UserCustomersMst/UpdateUserCustomerData',
    method: HTTP_METHOD.POST
  },

  // 権限リストの検索
  SearchUserRole: {
    url: '/UserMst/SearchUserRole',
    method: HTTP_METHOD.POST
  },

  // 権限リストの変更
  UpdateUserRole: {
    url: '/UserMst/UpdateUserRole',
    method: HTTP_METHOD.POST
  },

  // 取得会社マスタ情報
  GetCmpMstInfo: {
    url: '/CompanyMst/GetCmpMstInfo',
    method: HTTP_METHOD.POSTdit
  },

  // 编辑会社マスタ情報
  EditCmpMstInfo: {
    url: '/CompanyMst/EditCmpMstInfo',
    method: HTTP_METHOD.POST
  },

  //採番一覧：検索条件リストの初期化(状態)
  InitNumberSearchList: {
    url: '/NumberBasic/InitNumberSearchList',
    method: HTTP_METHOD.POST
  },

  //採番一覧：取得採番台帳基本情報
  GetNumberBasicInfo: {
    url: '/NumberBasic/GetNumberBasicInfo',
    method: HTTP_METHOD.POST
  },

  //採番一覧：削除採番台帳基本情報
  DeleteNumberBasicInfo: {
    url: '/NumberBasic/DeleteNumberBasicInfo',
    method: HTTP_METHOD.POST
  },

  //採番一覧：出力採番台帳情報
  OutPutNumberExcel: {
    url: '/NumberBasic/OutPutNumberExcel',
    method: HTTP_METHOD.POST
  },
  //採番詳細：リストの初期化(担当者、見積状態)
  InitNumberDetailList: {
    url: '/NumberDetail/InitNumberDetailList',
    method: HTTP_METHOD.POST
  },

  //採番詳細：リストの初期化(得意先担当者)
  InitNumberDetailCusUserList: {
    url: '/NumberDetail/InitNumberDetailCusUserList',
    method: HTTP_METHOD.POST
  },

  //採番詳細：取得採番台帳情報
  SearchNumberDetailByNbQuoteNo: {
    url: '/NumberDetail/SearchNumberDetailByNbQuoteNo',
    method: HTTP_METHOD.POST
  },

  //採番詳細：新規採番台帳情報
  AddNumberInfo: {
    url: '/NumberDetail/AddNumberInfo',
    method: HTTP_METHOD.POST
  },

  //採番詳細：編集採番台帳情報
  EditNumberInfo: {
    url: '/NumberDetail/EditNumberInfo',
    method: HTTP_METHOD.POST
  },

  //採番詳細：取得採番台帳情報(処理)
  SearchNumberDetailProcessingByNbQuoteNo: {
    url: '/NumberDetail/SearchNumberDetailProcessingByNbQuoteNo',
    method: HTTP_METHOD.POST
  },

  //採番詳細：編集採番台帳情報(処理)
  EditNumberInfoByProcessing: {
    url: '/NumberDetail/EditNumberInfoByProcessing',
    method: HTTP_METHOD.POST
  },

  //採番詳細：編集採番台帳情報(得意先)
  EditNumberInfoByCustomer: {
    url: '/NumberDetail/EditNumberInfoByCustomer',
    method: HTTP_METHOD.POST
  },

  //採番詳細：取得採番台帳情報(得意先)
  SearchNumberDetailCustomerByNbQuoteNo: {
    url: '/NumberDetail/SearchNumberDetailCustomerByNbQuoteNo',
    method: HTTP_METHOD.POST
  },

  //採番詳細：再度見積
  EstimateAgain: {
    url: '/NumberDetail/EstimateAgain',
    method: HTTP_METHOD.POST
  },

  //採番詳細：再度受注
  OrderAgain: {
    url: '/NumberDetail/OrderAgain',
    method: HTTP_METHOD.POST
  },

  //採番詳細：編集採番台帳情報(見積書情報と本社情報)
  EditNumberInfoEsimateAndCompany: {
    url: '/NumberDetail/EditNumberInfoEsimateAndCompany',
    method: HTTP_METHOD.POST
  },

  //採番詳細：すべてのレートを取得する
  GetAllRate: {
    url: '/NumberDetail/GetAllRate',
    method: HTTP_METHOD.POST
  },

  //  取得担当者情報
  GetMgrMstInfo: {
    url: '/ManagerInfoMst/GetMgrMstInfo',
    method: HTTP_METHOD.POST
  },

  // 编辑担当者情報
  ChangeMgrMstInfo: {
    url: '/ManagerInfoMst/ChangeMgrMstInfo',
    method: HTTP_METHOD.POST
  },

  // 削除担当者情報
  DeleteMgrMstInfo: {
    url: '/ManagerInfoMst/DeleteMgrMstInfo',
    method: HTTP_METHOD.POST
  },

  // 新規担当者情報
  AddMgrMstInfo: {
    url: '/ManagerInfoMst/AddMgrMstInfo',
    method: HTTP_METHOD.POST
  },

  // 検索入荷基本情報
  GetCheckReceBasicInfo: {
    url: '/CheckReceInfo/GetCheckReceBasicInfo',
    method: HTTP_METHOD.POST
  },

  // 入荷詳細画面選択情報の取得
  GetReceDetialSelectInfo: {
    url: '/CheckReceInfo/GetReceDetialSelectInfo',
    method: HTTP_METHOD.POST
  },

  GetReceDetialInfoByReceNo: {
    url: '/CheckReceInfo/GetReceDetialInfoByReceNo',
    method: HTTP_METHOD.POST
  },

  // 入荷No情報の取得
  GetReceNoInfo: {
    url: '/CheckReceInfo/GetReceNoInfo',
    method: HTTP_METHOD.POST
  },

  // 新規入荷詳細情報
  CreatReceDeatilInfo: {
    url: '/CheckReceInfo/CreatReceDeatilInfo',
    method: HTTP_METHOD.POST
  },

  // 新規入荷詳細情報
  CreatReceInfo: {
    url: '/CheckReceInfo/CreatReceInfo',
    method: HTTP_METHOD.POST
  },

  // 变更入荷詳細情報
  ChangeReceInfo: {
    url: '/CheckReceInfo/ChangeReceInfo',
    method: HTTP_METHOD.POST
  },

  // 注文製品選択情報の取得
  GetReceOrderSelectInfo: {
    url: '/CheckReceInfo/GetReceOrderSelectInfo',
    method: HTTP_METHOD.POST

  },

  // 検査室入荷情報の削除
  DeleteReceInfo: {
    url: '/CheckReceInfo/DeleteReceInfo',
    method: HTTP_METHOD.POST
  },

  // 入荷チェックリスト出力
  OutReceInfoByExcel: {
    url: '/CheckReceInfo/OutReceInfoByExcel1',
    method: HTTP_METHOD.POST,
    isBlob: true
  },

  SearchCheckReceByDeliceryFile: {
    url: '/CheckReceInfo/SearchCheckReceByDeliceryFile',
    method: HTTP_METHOD.POST
  },

  // 用户情報の取得
  GetUserInfoData: {
    url: '/UserMst/GetUserMstInfo',
    method: HTTP_METHOD.POST
  },

  GetUserInfoDataById: {
    url: '/UserMst/InitForChange',
    method: HTTP_METHOD.POST
  },

  // ADD 2025/11/13 ZLL 課題_ユーザログインのMFA認証処理の追加 start↓
  GetLoginUserInfoById: {
    url: '/UserMst/InitForLogin',
    method: HTTP_METHOD.POST
  },
  // 認証コードのチェック、信頼デバイスを設定
  ChkCodeSetTrustDev: {
    url: '/UserMst/ChkCodeSetTrustDev',
    method: HTTP_METHOD.POST
  },
  // ADD 2025/11/13 ZLL 課題_ユーザログインのMFA認証処理の追加 end↑

  DelUserInfoData: {
    url: '/UserMst/DeleteUserInfoData',
    method: HTTP_METHOD.POST
  },

  // 新規用户情報
  CreateUserInfoData: {
    url: '/UserMst/Entry',
    method: HTTP_METHOD.POST
  },

  // 編集用户情報
  ChangeUserInfoData: {
    url: '/UserMst/Change',
    method: HTTP_METHOD.POST
  },

  //受注一覧：受注基本情報の検索
  SearchAcceptOrderBasic: {
    url: '/AcceptOrderBasic/SearchAcceptOrderBasic',
    method: HTTP_METHOD.POST
  },

  //受注一覧：検索条件リストの初期化(状態)
  InitAcceptOrderSearchList: {
    url: '/AcceptOrderBasic/InitAcceptOrderSearchList',
    method: HTTP_METHOD.POST
  },

  //受注一覧：受注情報の削除
  DeleteAcceptInfoByQuoteNo: {
    url: '/AcceptOrderBasic/DeleteAcceptInfoByQuoteNo',
    method: HTTP_METHOD.POST
  },

  //受注一覧：出力受注台帳情報
  OutPutAcceptOrderExcel: {
    url: '/AcceptOrderBasic/OutPutAcceptOrderExcel',
    method: HTTP_METHOD.POST
  },
  //受注明細：基本情報のリスト取得（得意先担当者、担当者、状態）
  GetAcceptOrderDetailInitInfoList: {
    url: '/AcceptOrderDetail/GetInitInfoList',
    method: HTTP_METHOD.POST
  },

  //受注明細：受注No.による受注詳細情報の取得
  SearchAcceptOrderDetailByAcceptOrderNo: {
    url: '/AcceptOrderDetail/SearchAcceptOrderDetailByAcceptOrderNo',
    method: HTTP_METHOD.POST
  },

  //受注明細：受注基本と詳細情報の新規作成
  AddAcceptOrderDetail: {
    url: '/AcceptOrderDetail/AddAcceptOrderDetail',
    method: HTTP_METHOD.POST
  },

  //受注明細：再度受注処理
  AddReacceptOrderDetail: {
    url: '/AcceptOrderDetail/AddReacceptOrderDetail',
    method: HTTP_METHOD.POST
  },

  //受注明細：受注No.による受注詳細情報の更新
  UpdateAcceptOrderDetail: {
    url: '/AcceptOrderDetail/UpdateAcceptOrderDetail',
    method: HTTP_METHOD.POST
  },

  //加工詳細：受注情報から注文情報の取得
  SearchOrderInfoFromAcceptInfo: {
    url: '/AcceptOrderDetail/SearchOrderInfoFromAcceptInfo',
    method: HTTP_METHOD.POST
  },

  //
  GetCommonInfoList: {
    url: '/AcceptOrderDetail/GetCommonInfoList',
    method: HTTP_METHOD.POST
  },

  //得意先会社リストの取得
  GetCustomersList: {
    url: '/AcceptOrderDetail/GetCustomersList',
    method: HTTP_METHOD.POST
  },

  //受注可能採番一覧の取得
  GetAcceptableNumber: {
    url: '/AcceptOrderDetail/GetAcceptableNumber',
    method: HTTP_METHOD.POST
  },

  //採番情報から受注可能製品の取得
  GetAcceptProductFromNumber: {
    url: '/AcceptOrderDetail/GetAcceptProductFromNumber',
    method: HTTP_METHOD.POST
  },

  //採番情報から受注した詳細製品情報の取得
  GetAcceptedDetailInfoFromNumber: {
    url: '/AcceptOrderDetail/GetAcceptedDetailInfoFromNumber',
    method: HTTP_METHOD.POST
  },

  //納品異常情報の検索
  SearchProductExInfoByAobQuoteNo: {
    url: '/AcceptOrderDetail/SearchProductExInfoByAobQuoteNo',
    method: HTTP_METHOD.POST
  },

  // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
  // 納期、注番の変更(見積単位⇒製品単位に変更)
  //納品異常情報の保存
    SaveProductExInfoByAobQuoteNo: {
      url: '/AcceptOrderDetail/SaveProductExInfoByAobQuoteNo',
      method: HTTP_METHOD.POST
    },
  // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

  //通常製品情報の検索
  SearchProductNormalInfoByAobQuoteNo: {
    url: '/AcceptOrderDetail/SearchProductNormalInfoByAobQuoteNo',
    method: HTTP_METHOD.POST
  },

  //製品クローズ選択の更新
  UpdateProductCloseSelectData:{
     url: '/AcceptOrderDetail/UpdateProductCloseSelectData',
    method: HTTP_METHOD.POST
  },

  // 製品数変更基本情報の検索
  GetProductQtyBasicData: {
    url: '/AcceptOrderDetail/GetProductQtyBasicData',
    method: HTTP_METHOD.POST
  },

    // 製品数変更詳細情報の検索
  GetProductQtyDetailData: {
    url: '/AcceptOrderDetail/GetProductQtyDetailData',
    method: HTTP_METHOD.POST
  },


    // 製品数変更詳細情報の新規追加
  CreatProductQtyDetailData: {
    url: '/AcceptOrderDetail/CreatProductQtyDetailData',
    method: HTTP_METHOD.POST
  },

  // 製品数変更：注文明細情報の新規追加
    CreatProductQtyOrderDetailData: {
    url: '/AcceptOrderDetail/CreatProductQtyOrderDetailData',
    method: HTTP_METHOD.POST
  },
  // 製品数変更：注文明細情報のの削除
    DelProductQtyData: {
    url: '/AcceptOrderDetail/DelProductQtyData',
    method: HTTP_METHOD.POST
  },

  // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
  // 課題_備考機能の追加
  // 受注備考を更新する
  UpdateAodRemarks: {
    url: '/AcceptOrderDetail/UpdateAodRemarks',
    method: HTTP_METHOD.POST
  },
  // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

  // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
  // 課題_納期分割機能の追加
  // 製品分割、製品補足、製品クローズ画面：データ検索
   SearchAodProdInfoByProdNo: {
    url: '/AcceptOrderDetail/SearchAodProdInfoByProdNo',
    method: HTTP_METHOD.POST
  },
  // 製品分割、製品補足、製品クローズ画面：データ保存
   UpdAodProdInfo: {
    url: '/AcceptOrderDetail/UpdAodProdInfo',
    method: HTTP_METHOD.POST
  },
  // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑


  // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
  // 課題_発送予定機能の追加
  /*************発送予定用*************/
  // 発送予定一覧：検索条件リストの初期化(状態)
  InitPrepTransSearchList: {
    url: '/PrepTransBasic/InitPrepTransSearchList',
    method: HTTP_METHOD.POST
  },

  // 検索発送予定一覧情報
  SearchPrepTransBasic: {
    url: '/PrepTransBasic/SearchPrepTransBasic',
    method: HTTP_METHOD.POST
  },

  // 発送予定一覧：発送予定No.によると、発送予定基本情報と明細情報の削除
  DelPrepTransBasicByNo: {
    url: '/PrepTransBasic/DelPrepTransBasicByNo',
    method: HTTP_METHOD.POST
  },

  //=========================発送予定詳細画面=========================
  // 発送予定明細：基本情報のリスト取得（運送状態、担当者、輸送方式、製品異常区分、仕入先リスト）
  GetInitList: {
    url: '/PrepTransDetail/GetInitList',
    method: HTTP_METHOD.POST
  },
  // 発送予定明細：発送予定No.によると、発送予定基本情報と明細情報の検索
  SearchPrepTransDetailByNo: {
    url: '/PrepTransDetail/SearchPrepTransDetailByNo',
    method: HTTP_METHOD.POST
  },
  // 発送予定明細：明細情報の削除
  DelPrepTransByDetailNo: {
    url: '/PrepTransDetail/DelPrepTransByDetailNo',
    method: HTTP_METHOD.POST
  },
  // 発送予定製品選択画面：製品情報の検索
  SearchProdSelectInfo: {
    url: '/PrepTransDetail/SearchProdSelectInfo',
    method: HTTP_METHOD.POST
  },
  // 発送予定製品選択画面：製品情報の検索⇒発送予定明細
  GetProdSelectData: {
    url: '/PrepTransDetail/GetProdSelectData',
    method: HTTP_METHOD.POST
  },
  // 発送予定明細：発送予定基本情報と明細情報の新規追加
  AddPrepTransDetail: {
    url: '/PrepTransDetail/AddPrepTransDetail',
    method: HTTP_METHOD.POST
  },
  // 発送予定明細：発送予定No.によると、発送予定基本情報と明細情報の更新
  UpdPrepTransDetail: {
    url: '/PrepTransDetail/UpdPrepTransDetail',
    method: HTTP_METHOD.POST
  },
  // 発送予定明細：運送データの作成
  TransInfoCreate: {
    url: '/PrepTransDetail/TransInfoCreate',
    method: HTTP_METHOD.POST
  },
  // 発送予定明細：「発送予定単出力」の出力
  OutPutPrepTransToExcel: {
    url: '/PrepTransDetail/OutPutPrepTransToExcel',
    method: HTTP_METHOD.POST
  },
  // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

 /*************運送用*************/
  // 検索運送一覧情報
  SearchTransBasic: {
    url: '/TransBasic/SearchTransBasic',
    method: HTTP_METHOD.POST
  },

  // 削除運送一覧情報
  DeleteTransBasicByTransNo: {
    url: '/TransBasic/DeleteTransBasicByTransNo',
    method: HTTP_METHOD.POST
  },

  //運送一覧：検索条件リストの初期化(状態)
  InitTransSearchList: {
    url: '/TransBasic/InitTransSearchList',
    method: HTTP_METHOD.POST
  },

  //運送一覧：基本情報のリスト取得（仕入先、担当者）
  GetTransInitList: {
    url: '/TransDetail/GetTransInitList',
    method: HTTP_METHOD.POST
  },

  //運送明細：運送No.によると、運送基本情報と明細情報の検索
  SearchTransDetailByTransNo: {
    url: '/TransDetail/SearchTransDetailByTransNo',
    method: HTTP_METHOD.POST
  },

  //運送製品選択画面：情報の検索
  SearchTransSelectInfo: {
    url: '/TransDetail/SearchTransSelectInfo',
    method: HTTP_METHOD.POST
  },
  //運送明細：運送No.によると、運送基本情報と明細情報の更新
  UpdateTransDetail: {
    url: '/TransDetail/UpdateTransDetail',
    method: HTTP_METHOD.POST
  },
  //運送明細：運送基本情報と明細情報の新規追加
  AddTransDetail: {
    url: '/TransDetail/AddTransDetail',
    method: HTTP_METHOD.POST
  },
  //運送製品選択画面：情報の検索⇒運送明細
  GetTransSelectData: {
    url: '/TransDetail/GetTransSelectData',
    method: HTTP_METHOD.POST
  },

  //運送:運送単出力
  OutPutTransportToExcel: {
    url: '/TransDetail/OutPutTransportToExcel',
    method: HTTP_METHOD.POST,
  },
  /*************運送用*************/


  /*************日本入荷用*************/
  //日本入荷一覧：基本情報のリスト取得（日本入荷工場、日本入荷状態、支払状態、ユーザーリスト、仕入先リスト）
  InitJpReceSearchList: {
    url: '/JpReceBasic/InitJpReceSearchList',
    method: HTTP_METHOD.POST
  },

  //検索日本入荷一覧情報
  SearchJpReceBasic: {
    url: '/JpReceBasic/SearchJpReceBasic',
    method: HTTP_METHOD.POST
  },

  //日本入荷一覧：日本入荷No.によると、日本入荷基本情報と明細情報の削除
  DeleteJpReceBasicByNo: {
    url: '/JpReceBasic/DeleteJpReceBasicByNo',
    method: HTTP_METHOD.POST
  },
  //日本入荷明細：基本情報のリスト取得（日本入荷状態、支払状態、ユーザーリスト、仕入先リスト）
  GetJpReceInitList: {
    url: '/JpReceDetail/GetJpReceInitList',
    method: HTTP_METHOD.POST
  },
  //日本入荷明細：日本入荷No.によると、日本入荷基本情報と明細情報の検索
  SearchJpReceDetailByReceNo: {
    url: '/JpReceDetail/SearchJpReceDetailByReceNo',
    method: HTTP_METHOD.POST
  },
  //日本入荷運送選択画面：情報の検索
  SearchJpReceTransSelect: {
    url: '/JpReceDetail/SearchJpReceTransSelect',
    method: HTTP_METHOD.POST
  },
  //運送選択画面：情報の検索
  GetTransSelect: {
    url: '/JpReceDetail/GetTransSelect',
    method: HTTP_METHOD.POST
  },
  //日本入荷明細：日本入荷No.によると、日本入荷基本情報と明細情報の更新
  UpdateJpReceDetail: {
    url: '/JpReceDetail/UpdateJpReceDetail',
    method: HTTP_METHOD.POST
  },
  //日本入荷明細：日本入荷基本情報と明細情報の新規追加
  AddJpReceDetail: {
    url: '/JpReceDetail/AddJpReceDetail',
    method: HTTP_METHOD.POST
  },
  //日本入荷基本：新規の場合、日本入荷No.の取得
  GetAddJpReceNo: {
    url: '/JpReceDetail/GetAddJpReceNo',
    method: HTTP_METHOD.POST
  },
  //日本入荷詳細画面（大連以外の工場）：注文製品選択情報の検索
  GetOrderSelect: {
    url: '/JpReceDetail/GetOrderSelect',
    method: HTTP_METHOD.POST
  },
  //日本入荷詳細画面（大連以外の工場）：注文製品選択情報⇒日本入荷詳細
  GetOrderSelectedData: {
    url: '/JpReceDetail/GetOrderSelectedData',
    method: HTTP_METHOD.POST
  },
  //再入荷申請確認画面：再入荷情報は注文情報に保存される
  SaveReceAgainOrderInfo: {
    url: '/JpReceDetail/SaveReceAgainOrderInfo',
    method: HTTP_METHOD.POST
  },
  //再入荷申請確認画面：注文明細データの取得
  GetOrderDetailForm: {
    url: '/JpReceDetail/GetOrderDetailForm',
    method: HTTP_METHOD.POST
  },
  //日本入荷詳細画面（大連工場）：日本入荷No.によると、日本入荷基本情報と明細情報の検索
  GetJpReceDetailJP: {
    url: '/JpReceDetail/GetJpReceDetailJP',
    method: HTTP_METHOD.POST
  },
  // ADD 2025/07/01 Wjx 課題_数量·納期調整機能の追加 start↓
  //入荷異常画面：データ検索
  SearchReceProdInfoByProdNo: {
    url: '/JpReceDetail/SearchReceProdInfoByProdNo',
    method: HTTP_METHOD.POST
  },
  //入荷異常画面：データ更新
  UpdateReceNgInfo: {
    url: '/JpReceDetail/UpdateReceNgInfo',
    method: HTTP_METHOD.POST
  },
  // ADD 2025/07/01 Wjx 課題_数量·納期調整機能の追加 end↑

  // ADD 2025/08/21 WZC 課題_日本入荷の配送単導入機能の追加 start↓
  SearchJpReceByDeliceryFile: {
    url: '/JpReceDetail/SearchJpReceByDeliceryFile',
    method: HTTP_METHOD.POST
  },
  // ADD 2025/08/21 WZC 課題_日本入荷の配送単導入機能の追加 end↑

  /*************日本入荷用*************/


  /*************出荷用*************/
  //出荷：検索条件リストの初期化(有無状態、請求状態、出荷状態、得意先リスト、ユーザーリスト、仕入先リスト)
  InitSendSearchList: {
    url: '/SendBasic/InitSendSearchList',
    method: HTTP_METHOD.POST
  },

  // ADD 2025/12/24 ZLL 課題_251224顧客からの改善したい点への対応 start↓
  // 納品台帳出力機能の追加
  OutPutSendExcel: {
    url: '/SendBasic/OutPutSendExcel',
    method: HTTP_METHOD.POST
  },
  // ADD 2025/12/24 ZLL 課題_251224顧客からの改善したい点への対応 end↑

  //出荷一覧：検索出荷一覧情報
  SearchSendBasic: {
    url: '/SendBasic/SearchSendBasic',
    method: HTTP_METHOD.POST
  },
  //出荷一覧：出荷No.によると、出荷基本情報と明細情報の削除
  DeleteSendBasicByNo: {
    url: '/SendBasic/DeleteSendBasicByNo',
    method: HTTP_METHOD.POST
  },
  //出荷詳細画面：出荷No.によると、出荷基本情報と明細情報の検索
  SearchSendDetailByNo: {
    url: '/SendDetail/SearchSendDetailByNo',
    method: HTTP_METHOD.POST
  },
  //出荷詳細画面: 出荷No.によると、出荷基本情報と明細情報の更新
  UpdateSendDetail: {
    url: '/SendDetail/UpdateSendDetail',
    method: HTTP_METHOD.POST
  },
  //出荷詳細画面: 出荷基本情報と明細情報の新規追加
  AddSendDetail: {
    url: '/SendDetail/AddSendDetail',
    method: HTTP_METHOD.POST
  },

  //出荷製品選択画面：情報の検索
  SearchSendSelectInfo: {
    url: '/SendDetail/SearchSendSelectInfo',
    method: HTTP_METHOD.POST
  },
  //出荷製品選択画面：情報の検索⇒出荷詳細
  GetSendSelect: {
    url: '/SendDetail/GetSendSelect',
    method: HTTP_METHOD.POST
  },
  //得意先締め日の取得
  GetCusCalculateDate: {
    url: '/SendDetail/GetCusCalculateDate',
    method: HTTP_METHOD.POST
  },
  //納品異常処理画面：注文明細データ、受注明細データの取得
  GetAcceptOrderAndOrderDetail: {
    url: '/SendDetail/GetAcceptOrderAndOrderDetail',
    method: HTTP_METHOD.POST
  },
  //納品異常処理画面：納品異常情報は注文情報、受注情報に保存される
  SaveSendErrorData: {
    url: '/SendDetail/SaveSendErrorData',
    method: HTTP_METHOD.POST
  },
  //納品書、受領書出力
  OutPutDeliveryReceiptExcel: {
    url: '/SendDetail/OutPutDeliveryReceiptExcel',
    method: HTTP_METHOD.POST,
    // isBlob: true
  },

  //赤伝票出力
  OutPutSendErrExcel: {
    url: '/SendDetail/OutPutSendErrExcel',
    method: HTTP_METHOD.POST,
  },
  // ADD 2025/07/01 Wjx 課題_数量·納期調整機能の追加 start↓
  //納品異常画面：データ検索
  SearchSendProdInfoByProdNo: {
    url: '/SendDetail/SearchSendProdInfoByProdNo',
    method: HTTP_METHOD.POST
  },
  //納品異常画面：データ更新
  UpdateSendNgInfo: {
    url: '/SendDetail/UpdateSendNgInfo',
    method: HTTP_METHOD.POST
    },
  // ADD 2025/07/01 Wjx 課題_数量·納期調整機能の追加 end↑
/*************出荷用*************/

  /*************レポート用*************************↓****/
  // 意先月度別受注金額の検索
  SearchCusMOrderAmountData: {
    url: '/CusMOrderAmountReport/SearchCusMOrderAmountData',
    method: HTTP_METHOD.POST
  },

  // 年間発注実績データの検索
  SearchAnnualOrdersData: {
    url: '/CusMOrderAmountReport/SearchAnnualOrdersData',
    method: HTTP_METHOD.POST
  },

       //社内製造データののEXCEL出力
   OutCusMOrderAmountDataByExcel: {
    url: '/CusMOrderAmountReport/OutCusMOrderAmountDataByExcel',
    method: HTTP_METHOD.POST
  },

     //社内製造データののEXCEL出力
   OutAnnualOrdersDataByExcel: {
    url: '/CusMOrderAmountReport/OutAnnualOrdersDataByExcel',
    method: HTTP_METHOD.POST
  },

  //社内製造データの検索
  SearchInternalFactureData: {
    url: '/InternalFactureReport/SearchInternalFactureData',
    method: HTTP_METHOD.POST
  },

   //社内製造データののEXCEL出力
   OutInternalManufactureDataByExcel: {
    url: '/InternalFactureReport/OutInternalManufactureDataByExcel',
    method: HTTP_METHOD.POST
  },

      //社内製造データの更新
   UpdateInternalManufactureData: {
    url: '/InternalFactureReport/UpdateInternalManufactureData',
    method: HTTP_METHOD.POST
  },

  //担当者別の年間見積、受注実績の検索
  SearchAnnualNumberAndAcceptByUserData: {
    url: '/AnnualNumberAndAcceptByUserReport/SearchAnnualNumberAndAcceptByUserData',
    method: HTTP_METHOD.POST
  },

  // ADD 2024/12/16 ZLL 課題(#32906)_個人受注実績の見積件数が入力可能に変更 start↓
   //個人見積実績を保存
  UpdateAnnualNumberAndAcceptData: {
    url: '/AnnualNumberAndAcceptByUserReport/UpdateAnnualNumberAndAcceptData',
    method: HTTP_METHOD.POST
  },
  // ADD 2024/12/16 ZLL 課題(#32906)_個人受注実績の見積件数が入力可能に変更 end↑

  //個人受注実績報告データのEXCEL出力
  OutAnnualNumberAndAcceptByExcel: {
    url: '/AnnualNumberAndAcceptByUserReport/OutAnnualNumberAndAcceptByExcel',
    method: HTTP_METHOD.POST
  },

    // 個人売上詳細データのEXCEL出力
  OutAnnualSalesDetailByUserDataByExcel: {
    url: '/AnnualSalesByUserReport/OutAnnualSalesDetailByUserDataByExcel',
    method: HTTP_METHOD.POST
  },

  //担当者別の年間売上実績の検索
  SearchAnnualSalesByUserData: {
    url: '/AnnualSalesByUserReport/SearchAnnualSalesByUserData',
    method: HTTP_METHOD.POST
  },

  // 担当者別の年間売上実績出力
  OutPutSaleByUseReportInfo: {
    url: '/AnnualSalesByUserReport/OutPutSaleByUseReportInfo',
    method: HTTP_METHOD.POST,
  },

  //個人売上詳細の検索
  SearchAnnualSalesDetailByUserData: {
    url: '/AnnualSalesByUserReport/SearchAnnualSalesDetailByUserData',
    method: HTTP_METHOD.POST
  },

    //個人売上詳細の更新
  UpdateAnnualSalesDetailByUserData: {
    url: '/AnnualSalesByUserReport/UpdateAnnualSalesDetailByUserData',
    method: HTTP_METHOD.POST
  },

  // 年間売上実績の検索
  SearchAnnualSalesPerformData: {
    url: '/AnnualSalesReport/SearchAnnualSalesPerformData',
    method: HTTP_METHOD.POST
  },
  // 年間売上実績データの更新
  UpdateAnnualSalesPerformData: {
    url: '/AnnualSalesReport/UpdateAnnualSalesPerformData',
    method: HTTP_METHOD.POST
  },
  // 「月間売上実績」echartsデータの検索
  GetMonthSalesEChartData: {
    url: '/AnnualSalesReport/GetMonthSalesEChartData',
    method: HTTP_METHOD.POST
  },
  /*************レポート用*************************↑****/


  /*************書類設定用**************↓****/
  // 書類設定情報の取得
  GetDocSetInfoData: {
    url: '/DocumentSet/GetDocSetInfoData',
    method: HTTP_METHOD.POST
  },

  // 編集書類設定情報
  EditDocSetInfo: {
    url: '/DocumentSet/EditDocSetInfo',
    method: HTTP_METHOD.POST
  },

  //レートマスタデータの検索
  SearchExchangeRateData: {
    url: '/DocumentSet/SearchExchangeRateData',
    method: HTTP_METHOD.POST
  },

 //レートマスタデータの更新
 UpdateExchangeRateData: {
  url: '/DocumentSet/UpdateExchangeRateData',
  method: HTTP_METHOD.POST
},


  /*************書類設定用**************↑****/

/*************仕入先支払用*************/

  //仕入先支払一覧：検索条件リストの初期化(状態、支払状態)
  InitCustPaySearchList: {
    url: '/CustomerPayBasic/InitCustPaySearchList',
    method: HTTP_METHOD.POST
  },

   //仕入先支払一覧：仕入先支払基本情報の検索
   SearchCustPayBasic: {
    url: '/CustomerPayBasic/SearchCustPayBasic',
    method: HTTP_METHOD.POST
  },

  //仕入先支払一覧：仕入先支払No.によると、仕入先支払基本情報と明細情報の削除
   DeleteCustPayBasicByPayNo: {
    url: '/CustomerPayBasic/DeleteCustPayBasicByPayNo',
    method: HTTP_METHOD.POST
  },

  //勘定書出力
  OutPutAccountExcel: {
    url: '/CustomerPayBasic/OutPutAccountExcel',
    method: HTTP_METHOD.POST
  },

  //仕入先支払詳細画面：仕入先支払No.によると、仕入先支払基本情報と明細情報の検索
   SearchCusPayDetail: {
    url: '/CustomerPayDetail/SearchCusPayDetail',
    method: HTTP_METHOD.POST
  },

  //仕入先支払詳細画面：仕入先支払No.によると、仕入先支払基本情報と明細情報の検索
   SearchJpReceSelectForm: {
    url: '/CustomerPayDetail/SearchJpReceSelectForm',
    method: HTTP_METHOD.POST
  },

  //支払入荷選択画面情報の検索:⇒仕入先支払明細画面
   SearchJpReceToPayInfo: {
    url: '/CustomerPayDetail/SearchJpReceToPayInfo',
    method: HTTP_METHOD.POST
  },

  //支払入荷画面: 支払入荷No.によると、支払入荷基本情報と明細情報の更新
  UpdateCusPayDetail: {
    url: '/CustomerPayDetail/UpdateCusPayDetail',
    method: HTTP_METHOD.POST
  },

  //支払入荷画面: 支払入荷No.によると、支払入荷基本情報と明細情報の新規追加
  AddCusPayDetail: {
    url: '/CustomerPayDetail/AddCusPayDetail',
    method: HTTP_METHOD.POST
  },
  //支払詳細画面: 新規支払No取得
  GetNewPayNo: {
    url: '/CustomerPayDetail/GetNewPayNo',
    method: HTTP_METHOD.POST
  },
  //注文情報と日本入荷情報の検索
  SearchOrderJpReceInfo: {
    url: '/CustomerPayDetail/SearchOrderJpReceInfo',
    method: HTTP_METHOD.POST
  },
  //クローズデータ選択画面情報の検索
  SearchCloseSelectForm: {
    url: '/CustomerPayDetail/SearchCloseSelectForm',
    method: HTTP_METHOD.POST
  },
  //クローズデータ選択画面情報の検索
  SearchCloseToPayInfo: {
    url: '/CustomerPayDetail/SearchCloseToPayInfo',
    method: HTTP_METHOD.POST
  },
  /*************仕入先支払用*************/

  /*************請求台帳**************↑****/
  // 請求台帳情報の取得
  GetRequestBasicInfo:{
    url: '/RequestInfo/GetRequestBasicInfo',
    method: HTTP_METHOD.POST
  },

  DeleteRequestInfo: {
    url: '/RequestInfo/DeleteRequestInfo',
    method: HTTP_METHOD.POST
  },

  GetRequestSelectInfo: {
    url: '/RequestInfo/GetRequestSelectInfo',
    method: HTTP_METHOD.POST
  },

  GetRequestDetailInfoByNo: {
    url: '/RequestInfo/GetRequestDetailInfoByNo',
    method: HTTP_METHOD.POST
  },

  CreatRequestData: {
    url: '/RequestInfo/CreatRequestData',
    method: HTTP_METHOD.POST
    },

  ChangeRequestData: {
    url: '/RequestInfo/ChangeRequestData',
    method: HTTP_METHOD.POST
  },

  GetReqProductInfo: {
        url: '/RequestInfo/GetReqProductInfo',
    method: HTTP_METHOD.POST
  },

  GetReqProductDetailInfo: {
    url: '/RequestInfo/GetReqProductDetailInfo',
    method: HTTP_METHOD.POST
  },

  GetReqDetailInfo: {
    url: '/RequestInfo/GetReqDetailInfo',
    method: HTTP_METHOD.POST
  },

  OutPutRequestInfoToExcel: {
    url: '/RequestInfo/OutPutRequestInfoToExcel',
    method: HTTP_METHOD.POST
  },

  // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
  // 請求補足データ選択検索
  SearchSuppSelectInfo: {
    url: '/RequestInfo/SearchSuppSelectInfo',
    method: HTTP_METHOD.POST
  },
  // 請求補足データ⇒詳細
  GetReqSuppDetailInfo: {
    url: '/RequestInfo/GetReqSuppDetailInfo',
    method: HTTP_METHOD.POST
  },
  // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

  /*************請求台帳**************↑****/

  /*************共通設定*******************/
  GetCommonSetInfo: {
    url: '/CommonSet/GetCommonSetInfo',
    method: HTTP_METHOD.POST
  },
  ChangeCommonSetInfo: {
    url: '/CommonSet/ChangeCommonSetInfo',
    method: HTTP_METHOD.POST
  },
  /*************共通設定*******************/

  /*************受注データ取込*******************/
  //受注データ取込一覧：検索条件リストの初期化(取込担当者、受注状態)
  InitDataImportSearchList: {
    url: '/DataImportBasic/InitDataImportSearchList',
    method: HTTP_METHOD.POST
  },
  //受注データ取込一覧：検索受注データ取込台帳基本情報
  GetDataImportBasicInfo: {
    url: '/DataImportBasic/GetDataImportBasicInfo',
    method: HTTP_METHOD.POST
  },

  //受注データ取込一覧：削除受注データ取込基本情報
  DeleteDataImportBasicInfo: {
    url: '/DataImportBasic/DeleteDataImportBasicInfo',
    method: HTTP_METHOD.POST
  },

  //受注データ取込詳細：リストの初期化（取込担当者、タイプ、受注状態、得意先、仕入先、工場）
  InitDataImportDetailList: {
    url: '/DataImportDetail/InitDataImportDetailList',
    method: HTTP_METHOD.POST
  },

  //受注データ取込詳細：検索受注データ取込詳細情報
  searchDataImportDetailByDibNo: {
    url: '/DataImportDetail/SearchDataImportDetailByDibNo',
    method: HTTP_METHOD.POST
  },
  //受注データ取込詳細：得意先担当者リストの取得
  InitDataImportDetailCusUserList: {
    url: '/DataImportDetail/InitDataImportDetailCusUserList',
    method: HTTP_METHOD.POST
  },

  // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
  // 得意先コードリスト(受注担当者コードで)
  GetCusCodeForUserInfo: {
    url: '/DataImportDetail/GetCusCodeForUserInfo',
    method: HTTP_METHOD.POST
  },
  // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

  //受注データ取込詳細：一時保存・新規
  AddDataImportDetailByDibNo: {
    url: '/DataImportDetail/AddDataImportDetailByDibNo',
    method: HTTP_METHOD.POST
  },
  //受注データ取込詳細：一時保存・変更
  EditDataImportDetailByDibNo: {
    url: '/DataImportDetail/EditDataImportDetailByDibNo',
    method: HTTP_METHOD.POST
  },
  //受注データ取込詳細：受注データ作成
  AddAcceptInfoByDataImport: {
    url: '/DataImportDetail/AddAcceptInfoByDataImport',
    method: HTTP_METHOD.POST
  },
  //削除見積選択：削除された「見積No.」を検索する
  SearchRemovableQuoteNoByDIdNo: {
    url: '/DataImportDetail/SearchRemovableQuoteNoByDIdNo',
    method: HTTP_METHOD.POST
  },
  //削除見積選択：選択した「見積No.」を削除する
  DeleteDataImportInfoByQuoteNo: {
    url: '/DataImportDetail/DeleteDataImportInfoByQuoteNo',
    method: HTTP_METHOD.POST
  },
  /*************受注データ取込*******************/
}
